export default __webpack_public_path__ + "static/media/logos.cdd50177.svg";